<template>
  <article class="nuestrosComienzos">
    <section class="portada">
      <div class="linea">
        <h1>Nuestros Comienzos</h1>
      </div>
    </section>
    <section class="lineas">
      <div class="linea1"></div>
      <div class="linea2"></div>
      <div class="linea3"></div>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p>El desafío comenzó hace tiempo cuando la sociedad integrada por YPF S.A., Petrobras y Dow Argentina decidió a mediados de 1997 concretar un proyecto que explotara integralmente el gas natural. Así, con la concreción del mismo, los componentes ricos del gas natural pasaron a constituir el insumo básico de la industria del plástico, permitiendo la expansión de dicha industria fundamental para el crecimiento de la economía argentina.
            </p>
            <p>La inversión total del proyecto fue de U$S 715 millones, formados aproximadamente por U$S 506 millones de “hard costs”(ingeniería, provisión de equipos y construcción) y U$S 209 millones de “soft costs” (costos pre-operativos y de desarrollo, costos financieros, impuestos y otros). La financiación provino de préstamos a través de obligaciones negociables y del aporte de los socios.</p>
            <img src="./planta.jpg" class="img-fluid" alt="">
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'nuestrosComienzos',
  data () {
    return {
      msg: 'Nuestros comienzos'
    }
  }
}
</script>

<style lang="sass">

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/nuestros-comienzos-en/nuestrosComienzos-en.vue